import { render, staticRenderFns } from "./merchant-management.vue?vue&type=template&id=1f850ee0&"
import script from "./merchant-management.vue?vue&type=script&lang=ts&"
export * from "./merchant-management.vue?vue&type=script&lang=ts&"
import style0 from "./merchant-management.vue?vue&type=style&index=0&id=1f850ee0&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports